import { render } from "./account-list.vue?vue&type=template&id=96d2d4ac&scoped=true"
import script from "./account-list.vue?vue&type=script&lang=js"
export * from "./account-list.vue?vue&type=script&lang=js"

import "./account-list.vue?vue&type=style&index=0&id=96d2d4ac&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/workspace/tl-demo-web_v2.0.9.4/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-96d2d4ac"]])

export default __exports__